<template>
  <div>
    <v-radio-group
      :model-value="modelValue"
      @update:model-value="inputGender"
      inline
      mandatory
      hide-details
      color="primary"
    >
      <v-radio
        v-for="item in items"
        :key="item.label"
        :label="item.label"
        :value="item.value"
      >
      </v-radio>
    </v-radio-group>
  </div>
</template>

<script lang="ts">
import { defineComponent, PropType } from "vue";

export default defineComponent({
  name: "GenderPicker",

  emits: ["update:modelValue"],

  props: {
    modelValue: {
      type: [String, null] as PropType<string | null>,
      required: false,
      default: null,
    },
  },

  data() {
    return {
      items: [
        { label: "すべて", value: null },
        { label: "男性", value: "male" },
        { label: "女性", value: "female" },
      ],
    };
  },

  methods: {
    inputGender(gender: string | null) {
      this.$emit("update:modelValue", gender);
    },
  },
});
</script>
